export default __webpack_public_path__ + "static/media/pattern-bg.a60a3c85.png";